import envConfig from '@hulu/env-config';
import { getJwtTokenPayload } from 'mission-control-common-components';

import App from '../../App';

// CRITICAL: Must use require() not import - tslint breaks for launch-darkly-react-client-sdk
// DO NOT CONVERT TO IMPORT STATEMENT
// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
const { withLDProvider } = require('launchdarkly-react-client-sdk');

const tokenContext = getJwtTokenPayload(window.localStorage.id_token);

const buildSha = envConfig.REACT_APP_BUILD_SHA;

const LDProvider = withLDProvider({
  clientSideID: envConfig.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID,
  timeout: Number(envConfig.REACT_APP_LAUNCHDARKLY_TIMEOUT),
  // Tag every flag evaluation with the app id and deployed git SHA so LaunchDarkly's
  // Contexts ("From source") and Applications views show which UI build is live. The
  // SHA is injected by K8s as APP_VERSION and forwarded to the browser as
  // REACT_APP_BUILD_SHA (see serve/config/env-config.ts). Omitted when unset so local
  // dev is unaffected. Note: the option is `application`, not `applicationInfo`, for
  // launchdarkly-react-client-sdk v3 / js-client-sdk v3.
  options: {
    bootstrap: 'localStorage',
    ...(buildSha && {
      application: {
        id: 'mission-control-ui',
        version: buildSha,
      },
    }),
  },
  ...(tokenContext && {
    context: {
      kind: 'user',
      key: tokenContext.ams_user_id ?? undefined,
      email: tokenContext.email ?? undefined,
    },
  }),
})(App);

export default LDProvider;
